import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';

const topo = topoUtils.getNationalTopography();

class UsaOutline extends Component {

  shouldComponentUpdate(nextProps){
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;

    return widthDifferent || heightDifferent;
  }

  render() {
    const width = this.props.width || 500;
    const height = this.props.height || 500;
    const path = geoUtils.getAlbersUsaPath(width, height);

    return (
      <g className="UsaOutline">
        <path
          id="FIPS_0"
          className="hover_out"
          d={path(topo.land)}
        ></path>
      </g>
    )
  }
}

UsaOutline.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

export default UsaOutline


// WEBPACK FOOTER //
// ./src/charts/Map/UsaOutline.js